export default "__VITE_ASSET__CRk$XcEK__"